import React from 'react';
import { Link } from 'react-router-dom';
import { Waves, Anchor, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* Logo */}
        <div className="mb-8">
          <div className="flex items-center justify-center space-x-4 mb-6">
            <div className="relative">
              <Waves className="h-16 w-16 text-emerald-400" />
              <Anchor className="h-8 w-8 text-white absolute -bottom-2 -right-2" />
            </div>
            <h1 className="text-5xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
              Orca AI
            </h1>
          </div>
          <p className="text-slate-300 text-xl mb-2">Yacht Charter Intelligence Dashboard</p>
          <p className="text-slate-400 text-sm">
            Advanced analytics and insights for yacht charter brokers
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="space-y-4">
          <Link to="/login">
            <Button className="w-full bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 group">
              Access Dashboard
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Index;
